<template>
    <div class="my-5">
        <div v-if="!sourcingEnabled" class="d-flex align-items-center justify-content-center min-height-150">
            <div class="font-weight-bold text-muted font-size-100 text-center">
                {{ $t('vendorSourcing.moduleNotEnabled') }}<br />
                {{ $t('vendorSourcing.contactToUpgrade') }}
            </div>
        </div>
        <div v-if="sourcingEnabled" class="">
            <div class="d-flex justify-content-between align-items-baseline mb-3">
                <div class="d-flex align-items-center">
                    <h4 class="mb-0">{{ $t('vendorSourcing.responseHistory') }}</h4>
                    <b-button size="sm" variant="minimal-primary" class="ml-2" @click="refreshHistory">
                        <b-icon icon="arrow-repeat"></b-icon>
                        {{ $t('vendorSourcing.refresh') }}
                    </b-button>
                </div>
                <div class="">
                    <b-button
                        v-if="currentUserInfo.is_paid_seat"
                        variant="success"
                        @click="showInviteModal"
                    >{{ $t('vendorSourcing.inviteToSourcingEvents') }}</b-button>
                </div>
            </div>
            <CompanyRfxResponseHistory
                v-if="currentUserInfo.is_paid_seat"
                ref="sourcingHistory"
                :company-id="resource.id"
                class=""
            />
            <div
                v-else
                class="my-5 w-100 min-height-150 d-flex justify-content-center align-items-center"
            >
                <div class="font-weight-bold text-muted font-size-100">
                    {{ $t('vendorSourcing.historyNotAvailable') }}
                </div>
            </div>

            <b-modal
                v-model="inviteModalShowing"
                :title="$t('vendorSourcing.inviteModalTitle', { name: resource.name })"
                size="xl"
                hide-footer
                centered
                no-close-on-backdrop
            >
                <CompanyBulkInviteRfx
                    :company-id="resource.id"
                    @invites-sent="refreshHistory"
                    @done="inviteModalShowing = false"
                    @cancel="inviteModalShowing = false"
                />
            </b-modal>
        </div>
    </div>
</template>

<script>
import { currentUserInfoMixin, tenantInfoMixin } from "../../../js/custom-vue-mixins";
import CompanyRfxResponseHistory from "@/components/CompanyRfxResponseHistory.vue";
import CompanyBulkInviteRfx from "@/components/rfx_internal/CompanyBulkInviteRfx.vue";

export default {
    components: {
        CompanyRfxResponseHistory,
        CompanyBulkInviteRfx,
    },
    mixins: [currentUserInfoMixin, tenantInfoMixin],
    i18n: {
        messages: {
            en: {
                vendorSourcing: {
                    moduleNotEnabled: "The Sourcing module is not enabled for your account.",
                    contactToUpgrade: "Please contact Supplios to upgrade your account.",
                    responseHistory: "Response History",
                    refresh: "Refresh",
                    inviteToSourcingEvents: "Invite to Sourcing Events",
                    inviteModalTitle: "Invite {name} to Sourcing Events",
                    historyNotAvailable: "Sourcing History is not available based on your permissions.",
                },
            },
            es: {
                vendorSourcing: {
                    moduleNotEnabled: "El módulo de Sourcing no está habilitado para su cuenta.",
                    contactToUpgrade: "Comuníquese con Supplios para actualizar su cuenta.",
                    responseHistory: "Historial de Respuestas",
                    refresh: "Actualizar",
                    inviteToSourcingEvents: "Invitar a Eventos de Sourcing",
                    inviteModalTitle: "Invitar a {name} a Eventos de Sourcing",
                    historyNotAvailable: "El historial de Sourcing no está disponible según sus permisos.",
                },
            },
            pt: {
                vendorSourcing: {
                    moduleNotEnabled: "O módulo de Sourcing não está habilitado para a sua conta.",
                    contactToUpgrade: "Entre em contato com a Supplios para fazer upgrade da sua conta.",
                    responseHistory: "Histórico de Respostas",
                    refresh: "Atualizar",
                    inviteToSourcingEvents: "Convidar para Eventos de Sourcing",
                    inviteModalTitle: "Convidar {name} para Eventos de Sourcing",
                    historyNotAvailable: "O histórico de Sourcing não está disponível com base nas suas permissões.",
                },
            },
            "zh-Hans": {
                vendorSourcing: {
                    moduleNotEnabled: "您的账户未启用寻源模块。",
                    contactToUpgrade: "请联系 Supplios 升级您的账户。",
                    responseHistory: "回复历史",
                    refresh: "刷新",
                    inviteToSourcingEvents: "邀请参加寻源活动",
                    inviteModalTitle: "邀请 {name} 参加寻源活动",
                    historyNotAvailable: "根据您的权限，无法查看寻源历史。",
                },
            },
            "zh-Hant": {
                vendorSourcing: {
                    moduleNotEnabled: "您的帳戶未啟用尋源模組。",
                    contactToUpgrade: "請聯絡 Supplios 升級您的帳戶。",
                    responseHistory: "回覆歷史",
                    refresh: "重新整理",
                    inviteToSourcingEvents: "邀請參加尋源活動",
                    inviteModalTitle: "邀請 {name} 參加尋源活動",
                    historyNotAvailable: "根據您的權限，無法檢視尋源歷史。",
                },
            },
        },
    },
    props: ["resource"],
    data() {
        return {
            inviteModalShowing: false,
        }
    },
    computed: {
        sourcingEnabled() {
            return !this.$tenantInfo.custom_flags?.hide_sourcing;  // NOT hide_sourcing
        },
    },
    methods: {
        showInviteModal() {
            this.inviteModalShowing = true;
        },
        refreshHistory() {
            const historyRef = this.$refs['sourcingHistory'];  // might not be there!
            if (historyRef) {
                historyRef.refresh();
            }
        },
    }
};
</script>
